import { NAV_CATALOG_GROUPS } from "@/auth/nav";
import { isModuleEnabled } from "@/auth/modules";

export const FEATURE_ITEMS = NAV_CATALOG_GROUPS.flatMap(g => g.items);
export const DEFAULT_FREQUENT = ["/lab/coint", "/rps", "/positions", "/grid", "/alerts", "/watchlist"];
export function featurePath(path: string): string | null {
  const clean = (path.split(/[?#]/)[0] ?? "").replace(/\/$/, "") || "/";
  return [...FEATURE_ITEMS].sort((a, b) => b.to.length - a.to.length)
    .find(item => clean === item.to || (item.to !== "/" && clean.startsWith(`${item.to}/`)))?.to ?? null;
}
export function frequentItems(paths: string[], preferences: Record<string, unknown> | null | undefined) {
  const byPath = new Map(FEATURE_ITEMS.map(item => [item.to, item]));
  return [...new Set([...DEFAULT_FREQUENT, ...paths])].flatMap(path => {
    const item = byPath.get(path);
    return item && path !== "/" && path !== "/more-tools" && item.module !== "settings" && isModuleEnabled(preferences, item.module) ? [item] : [];
  }).slice(0, 14);
}
